import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/system'
import { classes, styles } from './use-styles'
import { Close as CloseIcon } from '@mui/icons-material'
import VideoID from '../videoid.component'

const StyledDialog = styled(Dialog)(styles)

function Ekyc(props) {
  const { idType, onCompleted, onError, onTimeout, onClose, open, onFailed } =
    props
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const handleClose = (event, reason) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      // ignore
      return
    }

    onClose()
  }

  return (
    <StyledDialog
      fullWidth
      fullScreen={isMobile}
      maxWidth="sm"
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        SCAN DOCUMENT
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: { xs: '50px', sm: '0px' } }}>
        <VideoID
          start
          idType={idType}
          onCompleted={onCompleted}
          onError={onError}
          onTimeout={onTimeout}
          onFailed={onFailed}
          className={classes.video}
        />
      </DialogContent>
    </StyledDialog>
  )
}

Ekyc.propTypes = {
  idType: PropTypes.string.isRequired,
  onCompleted: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onTimeout: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onFailed: PropTypes.func.isRequired,
}

export default Ekyc
